import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError, IOrgAuthenticate } from '@unfoldrtech/portal-mic'
import { IUserAuthenticateResponse } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { coreAPI } from '../services/coreAPI'
import { generateCorrelationId } from '../utils/helpers'
import firebaseAuth from '../services/firebaseAuth'

type TAuthenticateUserMutationResult = UseMutationResult<
  AxiosResponse<IUserAuthenticateResponse>,
  AxiosError<IError>,
  IOrgAuthenticate
>

export default function useAuthenticateUser() {
  return useMutation(
    ['authenticateUser'],
    (orgAuthenticate: IOrgAuthenticate) =>
      coreAPI
        .misc({
          accessToken: firebaseAuth.getIdToken(),
        })
        .authenticateUser(generateCorrelationId(), orgAuthenticate)
  ) as TAuthenticateUserMutationResult
}
